import React from 'react';
import { SubmitButton } from 'ui-builder';
import CreateDependentTaskButton from './CreateDependentTaskButton';
import DeletePlanTaskButton from './DeletePlanTaskButton';
import { PlanPermission, useAuthorizationChecker } from 'authorization-scope';

const buttonsContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
};

const leftGroupStyle: React.CSSProperties = {
  display: 'flex',
  gap: '1rem',
  alignItems: 'center',
};

export default function UpdateTaskButtons() {
  const { isGranted } = useAuthorizationChecker();

  if (isGranted(PlanPermission.CREATE_TASK)) {
    return (
      <div style={buttonsContainerStyle}>
        <div style={leftGroupStyle}>
          <SubmitButton text="Update task" key="submit" />
          <CreateDependentTaskButton key="dependent-task" />
        </div>
        <DeletePlanTaskButton />
      </div>
    );
  } else {
    return (
      <div style={buttonsContainerStyle}>
        <div style={leftGroupStyle}>
          <SubmitButton text="Update task" key="submit" />
        </div>
        <DeletePlanTaskButton key="delete" />
      </div>
    );
  }
}
